var BaseViews = require('./base');
var Subfilters = require('./menu/subfilters');
var MenuSlider = require('./menu/menu-slider');
var MenuItems = require('./menu/menu-items');
var MenuProductEntities = require('./menu/menu-product');
var LocationDisplay = require('./location-display');

require('../../scss/bootstrap.scss');
require('./menu/menu.scss');
var Menu = BaseViews.LayoutView.extend({
    _itemsView: null,
    _menuItems: null,
    _menuItemCategories: null,
    _menuState: null,
    template: require('./menu/menu.html'),
    className: 'fmcy-menu container-fluid',
    regions: {
        filtersRegion: '.fmcy-menu-filter-region',
        searchRegion: '.fmcy-menu-search-region',
        itemsRegion: '.fmcy-menu-items-region',
        locationDisplayRegion: '.fmcy-menu-location-display-region'
    },
    modelEvents: _.extend(
        {},
        _.result(BaseViews.LayoutView.prototype, 'modelEvents'),
        {
            'change:preSearch': 'preSearch'
        }
    ),
    initialize: function (options) {
        var self = this;
        self.options = _.defaults(
            options || {},
            {
                mode: 'menu', // menu|embedded|slider/kiosk,
                thumbStyle: 'thumb', // thumb|full
                menuItems: null,
                locationMapEnabled: false,
                searchPanelEnabled: false,
                filterPanelEnabled: false,
                locationSwitchingEnabled: true,
                scrollFetchingEnabled: false,
                shouldEnableOnlinePurhaseCallback: null,
                redirectURL: null
            }
        );

        _.bindAll(self, '_onScroll');
        self._menuState = self.model;
        self._menuItems = self._menuState.get('menuItems');
        self._menuItemCategories = self._menuState.get('menuItemCategories');

        self._onScroll = _.throttle(self._onScroll, 100);

        if (!self.options.shouldEnableOnlinePurhaseCallback) {
            throw new Error('Required menu paramaters not supplied: shouldEnableOnlinePurhaseCallback');
        }

        self.listenTo(
            self.options.appChannel,
            'product:loaded',
            function (productModel) {
                self.hideSearch();
                self.hideFilters();
                self.hideItems();
            }
        );
    },
    _onScroll: function(event) {
        var self = this;
        if (this._menuState.get('displayingExpandedView')) {
            return;
        }
        // need to figure this out better
        var scrollBottomBuffer = 1000;
        if (
            $(window).scrollTop() + $(window).height() >
            $(document).height() - scrollBottomBuffer
        ) {
          this.trigger('next:page');
        }

        if (this.options.filterPanelEnabled) {
          if ($(window).scrollTop() >= 150) {
            this.hideFilterPanelDebounce = _.debounce(function () {
              self._hideFilterPanel();
            }, 500, true);
            this.hideFilterPanelDebounce();
          } else {
            this._showFilterPanel();
          }
        }
    },
    onClose: function() {
        if (this.options.scrollFetchingEnabled) {
            $(window).off(this._onScroll);
        }
    },
    preSearch: function() {
        if (this._menuState.get('preSearch')) {
            this._menuState.set({ preSearch: false }, { silent: true });
            //this.hideProductThumbs();
        }
    },
    _hideFilterPanel: function () {
      /*
      this.filtersRegion.$el.css('overflow', 'hidden');
      Velocity(this.filtersRegion.$el, {
        height: 37,
      }, {
        duration: 250
      });
      */
    },
    _showFilterPanel: function () {
      var self = this;
      /*
      Velocity(this.filtersRegion.$el, {
        height: '',
      }, {
        duration: 250,
        delay: 250
      }).animate(self.itemsRegion.$el, {
                'padding-top': self.filtersRegion.$el.height(),
              }, {
                duration: 250
              });
              */
    },
    _renderFilterPanel: function () {
      var self = this;
      var filters =
          new Subfilters({
              model: self._menuState,
              appChannel: self.options.appChannel,
              locations: self.options.locations,
              showLocationsFilter: false
          });

      filters.on('product:selected', function (product) {
          if (product) {
              self.options.appChannel.request(
                  'load:product',
                  product.get('slug')
              );
          }
      });

      function checkLoadingProduct () {
          if (self._menuState.get('loadingProduct')) {
              self.hideSearch();
              self.hideFilters();
          }
      }

      checkLoadingProduct();

      filters.listenTo(this._menuState, 'change:loadingProduct', function () {
          checkLoadingProduct();
      });

      self.showChildView(
          'filtersRegion',
          filters
      );

      this.filtersRegion.$el.on('click', function () {
        self._showFilterPanel();
      });
    },
    _renderSearch: function () {
      // legacy search for kiosk...
    },
    maybeRenderLocationDisplay: function () {
      if (this.options.searchPanelEnabled) {
        this._renderLocationDisplay();
      }
    },
    _renderLocationDisplay: function () {
      this._locationDisplay = new LocationDisplay({
        _appChannel: this.options.appChannel,
        _menuState: this._menuState
      });
      this.locationDisplayRegion.show(this._locationDisplay);
    },
    _renderItems: function () {
        var self = this;
        function getItemDisplayImageURL (model, size) {
            if (size) {
                return model.getProductImageURL(size);
            } else if ($(window).width() >= 800) {
                return model.getProductImageURL(MenuProductEntities.PRODUCT_IMAGE_SIZES.MEDIUM);
            } else {
                return model.getProductImageURL(MenuProductEntities.PRODUCT_IMAGE_SIZES.THUMB);
            }
        }
        switch (self.options.mode) {
            case 'slider':
                self._itemsView = new MenuSlider({
                    getItemDisplayImageURL: getItemDisplayImageURL,
                    collection: self._menuItems,
                    appChannel: self.options.appChannel,
                    shouldEnableOnlinePurhaseCallback: self.options.shouldEnableOnlinePurhaseCallback
                });
                break;
            default:
                self._itemsView = new MenuItems(
                    {
                        locations: self.options.appChannel.request('get:locations'),
                        getItemDisplayImageURL: getItemDisplayImageURL,
                        collection: self._menuItems,
                        thumbStyle: self.options.thumbStyle, // full, thumb
                        isFetching: function () {
                            return self._menuState.get('retrievingPageData');
                        },
                        _menuState: self._menuState,
                        appChannel: self.options.appChannel,
                        locationSwitchingEnabled: self.options.locationSwitchingEnabled,
                        shouldEnableOnlinePurhaseCallback: self.options.shouldEnableOnlinePurhaseCallback,
                        showOnlineProductLocations: this.options.appChannel.request('is:user:logged:in'),
                        showProductLocations: function () {
                            // Only show product locations on the thumb if showing products from
                            // All Locations
                            return self._menuState.get('multiLocationsSupportEnabled') && self._menuState.get('filterLocation') === 'all';
                        }
                    }
                );
        }


        self._itemsView.on('thumb:clicked', function(model) {
            self.options.appChannel.request(
                'load:product',
                model.get('slug'),
                null,
                model
            );
        });

        function checkLoadingProduct () {
            if (self._menuState.get('loadingProduct')) {
                self.hideItems();
            }
        }

        checkLoadingProduct();
        self._itemsView.listenTo(this._menuState, 'change:loadingProduct', function () {
            checkLoadingProduct();
        });

        self.showChildView('itemsRegion', self._itemsView);

    },
    maybeShowFilters: function () {
        if (!this.isRendered) {
            return false;
        }

        if (this.options.filterPanelEnabled) {
            this.showFilters();
        }
    },
    showFilters: function() {
        var self = this;
        if (!this.isRendered) {
            return false;
        }
        this.filtersRegion.$el.removeClass('invisible');
        this.filtersRegion.$el.removeClass('hide');
        this.filtersRegion.$el.css('width');

        if (this.options.filterPanelEnabled) {
          /*
          _.delay(function () {
            Velocity(self.itemsRegion.$el, {
              'padding-top': self.filtersRegion.$el.height(),
            }, {
              duration: 250
            });
          }, 250);
          */
          // init controller
          /*
          if (this.scrollMagicController == null) {
            this.scrollMagicController = new ScrollMagic.Controller();

            // build scene
            this.scrollMagicScene = new ScrollMagic.Scene({triggerElement: '.fmcy-menu-filter-region', offset: 350})
                    // trigger a velocity opaticy animation
                    //.setVelocity('.fmcy-menu-filter-region', {height: 37}, {duration: 400})
                    .setPin('.fmcy-menu-filter-region')
                    .addIndicators() // add indicators (requires plugin)
                    .addTo(this.scrollMagicController);
          }
          */
        }
    },
    hideFilters: function() {
        if (!this.isRendered) {
            return false;
        }
        this.filtersRegion.$el.addClass('invisible');
    },
    maybeShowSearch: function () {
        if (!this.isRendered) {
            return false;
        }

        if (this.options.searchPanelEnabled) {
            this.showSearch();
        }
    },
    showSearch: function() {
        if (!this.isRendered) {
            return false;
        }
        this.searchRegion.$el.removeClass('invisible');
        this.searchRegion.$el.removeClass('hide');
    },
    hideSearch: function() {
        if (!this.isRendered) {
            return false;
        }
        this.searchRegion.$el.addClass('invisible');
    },

    showItems: function() {
        if (!this.isRendered) {
            return false;
        }
        this.itemsRegion.$el.removeClass('invisible');
        this.itemsRegion.$el.removeClass('hide');
    },
    hideItems: function() {
        if (!this.isRendered) {
            return false;
        }
        this.itemsRegion.$el.addClass('invisible');
    },
    hideProductThumbs: function() {
        var self = this;
        if (this._menuItems && this._menuItems.length) {
            this._menuItems.each(function(model) {
                if (self._itemsView) {
                    var thumbView = self._itemsView.children.findByModel(
                        model
                    );
                    if (thumbView) {
                        thumbView.hideThumb();
                    }
                }
            });
        }
    },
    serializeData: function () {
        return {
            options: this.options,
            menuState: this._menuState.toJSON()
        };
    },
    onRender: function() {
        var self = this;
        this._renderItems();
        if (this.options.searchPanelEnabled) {
            this._renderSearch();
        }

        this.$el.addClass('fmcy-menu-mode-' + this.options.mode);
        this.$el.addClass('fmcy-menu-thumbstyle-' + this.options.thumbStyle);

        if (this.options.filterPanelEnabled) {
          this._renderFilterPanel();
          /*
          $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
          _.delay(function () {
            Velocity(self.itemsRegion.$el, {
              'padding-top': self.filtersRegion.$el.height(),
            }, {
              duration: 250,
            });
          }, 150);
          */

        }

        if (this.options.scrollFetchingEnabled) {
            $(window).scroll(this._onScroll);
        }

        BaseViews.LayoutView.prototype.onRender.call(self);
    },
    _onWindowResize: function (event) {
      /*
      Velocity(this.itemsRegion.$el, {
        'padding-top': this.filtersRegion.$el.height(),
      }, {
        duration: 250,
      });
      */
    },
    onDestroy: function () {
      $(window).off('resize.' + this.cid);
      BaseViews.LayoutView.prototype.onDestroy.call(this);
    }
});
module.exports = Menu;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu.js
 **/